module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Import Result Details",
      "visible": _vm.dialogVisible,
      "width": "95%",
      "close-on-click-modal": false,
      "close-on-press-escape": true,
      "custom-class": "import-result-dialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('el-card', {
    staticClass: "summary-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "summary-title"
  }, [_vm._v("Import Summary")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.result.failedCount === 0) ? _c('el-tag', {
    attrs: {
      "type": "success",
      "size": "medium"
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-check"
  }), _vm._v(" All Successful\n        ")]) : (_vm.result.successCount === 0) ? _c('el-tag', {
    attrs: {
      "type": "danger",
      "size": "medium"
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-close"
  }), _vm._v(" All Failed\n        ")]) : _c('el-tag', {
    attrs: {
      "type": "warning",
      "size": "medium"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v(" Partial Success\n        ")])], 1)]), _vm._v(" "), _c('el-row', {
    staticClass: "summary-stats",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.result.totalCount))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Total Records")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "stat-card success"
  }, [_c('div', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.result.successCount))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Successful")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "stat-card failed"
  }, [_c('div', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(_vm.result.failedCount))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Failed")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-number"
  }, [_vm._v(_vm._s(Math.round((_vm.result.successCount / _vm.result.totalCount) * 100)) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Success Rate")])])])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    staticClass: "result-tabs",
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [(_vm.result.successCount > 0) ? _c('el-tab-pane', {
    attrs: {
      "name": "success"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-circle-check"
  }), _vm._v("\n        Success (" + _vm._s(_vm.result.successCount) + ")\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "toolbar"
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "Search tracking numbers...",
      "prefix-icon": "el-icon-search",
      "clearable": ""
    },
    model: {
      value: (_vm.successSearch),
      callback: function($$v) {
        _vm.successSearch = $$v
      },
      expression: "successSearch"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": _vm.exportSuccessData
    }
  }, [_c('i', {
    staticClass: "el-icon-download"
  }), _vm._v(" Export Success\n            ")])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.filteredSuccessData,
      "height": _vm.tableHeight,
      "stripe": "",
      "empty-text": _vm.successSearch ? 'No matching records found' : 'No successful records'
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "#",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tracking",
      "label": "Tracking Number",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "success",
            "size": "small"
          }
        }, [_vm._v(_vm._s(scope.row.tracking || scope.row))])]
      }
    }], null, false, 588595142)
  }), _vm._v(" "), (_vm.result.successDetails) ? _c('el-table-column', {
    attrs: {
      "prop": "items",
      "label": "Items",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.items) ? _c('div', [_vm._l((scope.row.items.slice(0, 3)), function(item) {
          return _c('el-tag', {
            key: item.upc,
            staticStyle: {
              "margin-right": "5px",
              "margin-bottom": "2px"
            },
            attrs: {
              "size": "mini"
            }
          }, [_vm._v("\n                  " + _vm._s(item.upc) + " (" + _vm._s(item.quantity) + ")\n                ")])
        }), _vm._v(" "), (scope.row.items.length > 3) ? _c('el-tag', {
          attrs: {
            "type": "info",
            "size": "mini"
          }
        }, [_vm._v("\n                  +" + _vm._s(scope.row.items.length - 3) + " more\n                ")]) : _vm._e()], 2) : _vm._e()]
      }
    }], null, false, 3145462316)
  }) : _vm._e(), _vm._v(" "), (_vm.result.successDetails) ? _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "Description",
      "show-overflow-tooltip": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.successData.length > _vm.successPageSize) ? _c('el-pagination', {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    },
    attrs: {
      "current-page": _vm.successCurrentPage,
      "page-size": _vm.successPageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.successData.length
    },
    on: {
      "current-change": _vm.handleSuccessPageChange
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.result.failedCount > 0) ? _c('el-tab-pane', {
    attrs: {
      "name": "failed"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-circle-close"
  }), _vm._v("\n        Failed (" + _vm._s(_vm.result.failedCount) + ")\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "toolbar"
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "Search content or error messages...",
      "prefix-icon": "el-icon-search",
      "clearable": ""
    },
    model: {
      value: (_vm.failedSearch),
      callback: function($$v) {
        _vm.failedSearch = $$v
      },
      expression: "failedSearch"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "200px",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "Filter by error type",
      "clearable": ""
    },
    model: {
      value: (_vm.errorTypeFilter),
      callback: function($$v) {
        _vm.errorTypeFilter = $$v
      },
      expression: "errorTypeFilter"
    }
  }, _vm._l((_vm.uniqueErrorTypes), function(errorType) {
    return _c('el-option', {
      key: errorType,
      attrs: {
        "label": errorType,
        "value": errorType
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.exportFailedData
    }
  }, [_c('i', {
    staticClass: "el-icon-download"
  }), _vm._v(" Export Failed\n            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning",
      "size": "small"
    },
    on: {
      "click": _vm.copyFailedData
    }
  }, [_c('i', {
    staticClass: "el-icon-document-copy"
  }), _vm._v(" Copy for Retry\n            ")])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.filteredFailedData,
      "height": _vm.tableHeight,
      "stripe": "",
      "empty-text": _vm.failedSearch || _vm.errorTypeFilter ? 'No matching records found' : 'No failed records'
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "#",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Line",
      "width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.lineNumber || scope.$index + 1))])]
      }
    }], null, false, 308761487)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Error Message",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "error-message-container"
        }, [_c('span', {
          staticClass: "error-message-text"
        }, [_vm._v("\n                  " + _vm._s(_vm.getDisplayErrorMessage(scope.row)) + "\n                ")]), _vm._v(" "), _c('el-button', {
          staticClass: "error-detail-btn",
          attrs: {
            "size": "mini",
            "type": "text",
            "icon": "el-icon-document",
            "title": "View full error message"
          },
          on: {
            "click": function($event) {
              return _vm.showFullErrorMessage(scope.row)
            }
          }
        })], 1)]
      }
    }], null, false, 2286998231)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text",
            "title": "Copy to clipboard"
          },
          on: {
            "click": function($event) {
              return _vm.copyToClipboard(scope.row.rawContent || scope.row.content)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-document-copy"
        })])]
      }
    }], null, false, 3022992866)
  })], 1), _vm._v(" "), (_vm.failedData.length > _vm.failedPageSize) ? _c('el-pagination', {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    },
    attrs: {
      "current-page": _vm.failedCurrentPage,
      "page-size": _vm.failedPageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.failedData.length
    },
    on: {
      "current-change": _vm.handleFailedPageChange
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.result.failedCount > 0) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.handleRetryFailed
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" Retry " + _vm._s(_vm.result.failedCount) + " Failed Record(s)\n    ")]) : _vm._e(), _vm._v(" "), (_vm.result.successCount > 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleContinue
    }
  }, [_c('i', {
    staticClass: "el-icon-check"
  }), _vm._v(" Continue Import Process\n    ")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39b5fece"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImportResultDialog.vue
// module id = 823
// module chunks = 1